import request from '../utils/request';
import { downloadFile } from '../utils/download';

/**
 * 获取会议室统计
 * @param roomIds
 * @param startDate
 * @param endDate
 * @param meetingName
 * @param locale
 * @param pageNo
 * @param pageSize
 * @param token
 * @returns {Object}
 */
export const getRoomReport = ({
  roomIds,
  startDate,
  endDate,
  meetingName,
  locale,
  pageNo,
  pageSize,
  token
}) => {
  const url = `/smartmeeting/smart/report/findRoomReport?token=${token}&roomIds=${roomIds}&pageNo=${pageNo}&pageSize=${pageSize}&roomName=${meetingName}&startDate=${startDate}&endDate=${endDate}&lang=${locale}`;
  return request(url);
};
export const getRoomStatisticsReport = ({
  roomIds,
  startDate,
  endDate,
  roomNames,
  locale,
  pageNo,
  pageSize,
  token
}) => {
  let roomNameStr = roomNames.replace(/(^\s*)|(\s*$)/g,"");
  const url = `/smartmeeting/smart/report/findRoomCountReport?token=${token}&roomIds=${roomIds}&pageNo=${pageNo}&pageSize=${pageSize}&roomNames=${roomNameStr}&startDate=${startDate}&endDate=${endDate}&lang=${locale}`;
  return request(url);
};

export const getMeetingReleaseReport = ({
  startDate,
  endDate,
  roomIds,
  locale
}) => {
  const url = `/smartmeeting/smart/report/getMeetingRlsReport?roomIds=${roomIds}&startDate=${startDate}&endDate=${endDate}&lang=${locale}`;
  return request(url);
};
/**
 * 获取会议室明细
 * @param roomIds 会议室Id
 * @param startDate 开始日期
 * @param endDate 结束日期
 * @param meetingName 会议室名称
 * @param locale  语言
 * @param pageNo  页数
 * @param pageSize  每页数量
 * @param token token
 * @returns {Object}
 */
export const getRoomDetail = ({
  roomIds,
  startDate,
  endDate,
  meetingName,
  locale,
  pageNo,
  pageSize
}) => {
  let roomName = meetingName.replace(/(^\s*)|(\s*$)/g,"");
  const url = `/smartmeeting/smart/report/findRoomMeetingReport?roomIds=${roomIds}&pageNo=${pageNo}&pageSize=${pageSize}&roomNames=${roomName}&startDate=${startDate}&endDate=${endDate}&lang=${locale}`;
  return request(url, {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  });
};

/**
 * 描述:获取用户预订报表
 * @param token         用户信息
 * @param deptIds       部门
 * @param creatorNames  创建人姓名
 * @param startDate     日期(时间戳)
 * @param endDate       日期(时间戳)
 * @param pageNo        分页编号
 * @param pageSize      每页数量
 * @param locale          语言
 */
export const getUserBookReport = ({
  token,
  deptIds,
  creatorNames,
  startDate,
  endDate,
  pageNo,
  pageSize,
  locale
}) => {
  const url = `/smartmeeting/smart/report/findCreatorMeetingReport?creatorNames=${creatorNames}&deptIds=${deptIds}&pageNo=${pageNo}&pageSize=${pageSize}&startDate=${startDate}&endDate=${endDate}&lang=${locale}`;
  return request(url, {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  });
};

/**
 *获取用户预订统计
 * @param startDate
 * @param endDate
 * @param userName
 * @param locale
 * @param pageNo
 * @param pageSize
 * @param token
 * @returns {Object}
 */
export const getuserReport = ({
  startDate,
  endDate,
  userName,
  locale,
  pageNo,
  pageSize,
  token
}) => {
  const url = `/smartmeeting/smart/report/findUserReport?token=${token}&pageNo=${pageNo}&pageSize=${pageSize}&userName=${userName}&startDate=${startDate}&endDate=${endDate}&lang=${locale}`;
  return request(url);
};
/**
 * 获取用户预订统计报表
 * @param startDate
 * @param endDate
 * @param userName
 * @param locale
 * @param pageNo
 * @param pageSize
 * @param token
 * @returns {Object}
 */
export const getUserStatisticsReport = ({
  startDate,
  endDate,
  userName,
  locale,
  pageNo,
  pageSize,
  token,
  deptIds
}) => {
  const url = `/smartmeeting/smart/report/findCreatorCountReport?token=${token}&deptIds=${deptIds}&pageNo=${pageNo}&pageSize=${pageSize}&creatorNames=${userName}&startDate=${startDate}&endDate=${endDate}&lang=${locale}`;
  return request(url);
};

export const findRoomReportDetail = ({
  token,
  roomId,
  startDate,
  endDate,
  lang,
  pageNo,
  pageSize
}) => {
  const url = `/smartmeeting/smart/report/findRoomReportDetail?token=${token}&pageNo=${pageNo}&pageSize=${pageSize}&roomId=${roomId}&startDate=${startDate}&endDate=${endDate}&lang=${lang}`;
  return request(url);
};

export const findRoomAbnormalDetail = ({
  token,
  roomId,
  startDate,
  endDate,
  abnormalType,
  lang,
  pageNo,
  pageSize
}) => {
  const url = `/smartmeeting/smart/report/findRoomUsedTimes?token=${token}&pageNo=${pageNo}&pageSize=${pageSize}&roomId=${roomId}&startDate=${startDate}&endDate=${endDate}&abnormalType=${abnormalType}&lang=${lang}`;
  return request(url);
};

export const findUserAbnormalDetail = ({
  token,
  userId,
  startDate,
  endDate,
  abnormalType,
  lang,
  pageNo,
  pageSize
}) => {
  const url = `/smartmeeting/smart/report/findUserAbnormalDetail?token=${token}&pageNo=${pageNo}&pageSize=${pageSize}&userId=${userId}&startDate=${startDate}&endDate=${endDate}&abnormalType=${abnormalType}&lang=${lang}`;
  return request(url);
};

export const findRoomUsedTimes = ({
  token,
  roomId,
  startDate,
  endDate,
  lang,
  pageNo,
  pageSize
}) => {
  const url = `/smartmeeting/smart/report/findRoomUsedTimes?token=${token}&pageNo=${pageNo}&pageSize=${pageSize}&roomId=${roomId}&startDate=${startDate}&endDate=${endDate}&lang=${lang}`;
  return request(url);
};

export const getRoomReportDownLoad = ({
  roomIds,
  startDate,
  endDate,
  roomNames,
  locale,
  token
}) => {
  const url = `/smartmeeting/smart/report/exportRoomMeetingReport?token=${token}&roomIds=${roomIds}&roomNames=${roomNames}&startDate=${startDate}&endDate=${endDate}&lang=${locale}`;
  downloadFile('', url);
};

export const getUserReportDownLoad = ({
  deptIds,
  startDate,
  endDate,
  creatorNames,
  locale,
  token
}) => {
  const url = `/smartmeeting/smart/report/exportCreatorMeetingReport?token=${token}&deptIds=${deptIds}&creatorNames=${creatorNames}&startDate=${startDate}&endDate=${endDate}&lang=${locale}`;
  downloadFile('', url);
};

export const getRoomAbnormalReportDownLoad = ({
  roomIds,
  startDate,
  endDate,
  roomNames,
  locale,
  token
}) => {
  const url = `/smartmeeting/smart/report/exportRoomCountReport?token=${token}&roomIds=${roomIds}&roomNames=${roomNames}&startDate=${startDate}&endDate=${endDate}&lang=${locale}`;
  downloadFile('', url);
};

export const getUserAbnormalReportDownLoad = ({
  deptIds,
  startDate,
  endDate,
  creatorNames,
  locale,
  token
}) => {
  const url = `/smartmeeting/smart/report/exportCreatorCountReport?token=${token}&deptIds=${deptIds}&creatorNames=${creatorNames}&startDate=${startDate}&endDate=${endDate}&lang=${locale}`;
  downloadFile('', url);
};


export const getMeetingReport = ({
  startDate,
  endDate,
  userName,
  locale,
  pageNo,
  pageSize,
  token
}) => {
  const url = `/smartmeeting/smart/report/findMeetingReport?startDate=${startDate}&endDate=${endDate}&userName=${userName}&pageNo=${pageNo}&pageSize=${pageSize}&lang=${locale}`;
  return request(url, {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  });
};

export const getMeetingReportDownLoad = ({
   startDate,
   endDate,
   userName,
   locale,
   token
}) => {
  const url = `/smartmeeting/smart/report/exportMeetingReport?token=${token}&startDate=${startDate}&endDate=${endDate}&userName=${userName}&lang=${locale}`;
  downloadFile('', url);
};
/**
 * 会议室占用详情
 * @param startDate
 * @param endDate
 * @param roomIds
 * @param locale
 * @returns {Promise<any | never>}
 */
export const getRoomOccupyReport = ({
   startDate,
   endDate,
   roomIds,
   locale
}) => {
  const url = `/smartmeeting/smart/report/getRoomOccReport?roomIds=${roomIds}&startDate=${startDate}&endDate=${endDate}&lang=${locale}`;
  return request(url);
};

/**
 * 会议计费报表
 * @param startDate
 * @param endDate
 * @param nodeCode
 * @param locale
 * @returns {*}
 */
export const getMeetingBillReport = ({startDate, endDate, nodeCode,  pageNo, pageSize,locale }) => {
  const url = `/smartmeeting/smart/report/getMeetingBillReport?startDate=${startDate}&endDate=${endDate}&nodeCode=${nodeCode}&pageNo=${pageNo}&pageSize=${pageSize}&lang=${locale}`;
  return request(url);
};
/**
 * 下载会议计费报表
 * @param startDate
 * @param endDate
 * @param nodeCode
 * @param locale
 * @param token
 */
export const getMeetingBillReportDownLoad = ({startDate, endDate, nodeCode, locale, token }) => {
  const url = `/smartmeeting/smart/report/exportMeetingBillReport?token=${token}&nodeCode=${nodeCode}&startDate=${startDate}&endDate=${endDate}&lang=${locale}`;
  downloadFile('', url);
};





// WEBPACK FOOTER //
// ./src/services/report.js